import { selectOrganization } from '@saaga/shared/store/slices/auth.slice'
import { useAppSelector } from '@saaga/shared/store/store'
import { type Dispatch, type SetStateAction, useEffect, useRef } from 'react'

import type { SidebarNavItem } from './sidebar-nav-item.interface'

export const useSidebarOrgReset = (
  setPage: Dispatch<SetStateAction<number>>,
  setAccumulatedItemList: Dispatch<SetStateAction<SidebarNavItem[]>>
): void => {
  const organization = useAppSelector(selectOrganization)
  const orgId = organization?.id ?? null
  const prevOrgIdRef = useRef(orgId)

  useEffect(() => {
    if (prevOrgIdRef.current === orgId) return
    prevOrgIdRef.current = orgId
    setPage(1)
    setAccumulatedItemList([])
  }, [orgId, setPage, setAccumulatedItemList])
}
